import { Component, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PlayerComponent } from 'src/app/components/player/player.component';
import { BookmarkService } from 'src/app/services/bookmarkService/bookmark-service.service';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { PlayMediaService } from 'src/app/services/playMediaService/play-media.service';
import { VPCService } from 'src/app/services/VPCService/vpc.service';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.less']
})
export class VideoPlayerComponent implements AfterViewInit {
  @ViewChild(PlayerComponent) player;
  showControls = false;
  lang;
  constructor(public dialogRef: MatDialogRef<VideoPlayerComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private bookmarkService: BookmarkService, private languageService: LanguageService, private vpcService: VPCService, private playMediaService: PlayMediaService) {
    this.lang = this.languageService.getLanguage();
  }

  /** Action which run after html is draw */
  ngAfterViewInit(): void {
    this.vpcService.lock(this.data.video.vpcToken, this.data.video.interval);
    this.detectControlsVisibility();
  }

  /** Detects if the shakaplayer ui components are visible or not */
  detectControlsVisibility() {
    setInterval(() => {
      this.showControls = this.player.ui ? this.player?.ui?.getControls()?.isOpaque() : true;
    }, 500);
  }

  /** Close player.*/
  closeVideoPlayer(closeDialog: Boolean) {
    return new Promise(resolve => {
      this.vpcService.unlock().then(vpc => {
        this.player.closeVideo().then(videoInfo => {
          // Add Bookmark
          if (this.data.videoType != "trailer") {
            this.bookmarkService.addBookmark({
              asset: this.data,
              seek: videoInfo.seek,
              percentage: videoInfo.percentage
            }).then((resp: any) => { });

            // Set Bookmark Info for episode
            if (this.data.currentEpisode) {
              videoInfo.episodeNumber = this.data.currentEpisode.episodeNumber;
              videoInfo.seasonNumber = this.data.currentEpisode.seasonNumber;
            }
          }

          // Decide if you should close video dialog or sent update details event
          if (closeDialog) {
            this.dialogRef.close(this.data.videoType != "trailer" ? videoInfo : null);
          } else {
            this.playMediaService.getPlayerStatus.next(videoInfo);
          }
          resolve(videoInfo);
        });
      });
    });
  }

  /** Actions triggered on video end  */
  onVideoEnd() {
    if (this.data?.seasons) {
      // Season
      let currentSeasonPos;
      let currentSeason = this.data.seasons.find((obj, pos) => {
        currentSeasonPos = pos;
        return obj.seasonNumber == this.data.currentEpisode.seasonNumber
      });

      // Episodes
      let currentEpisodePos;
      currentSeason?.episodes.find((obj, pos) => {
        currentEpisodePos = pos;
        return obj.episodeNumber == this.data.currentEpisode.episodeNumber
      });

      // Play Next episode from the same season
      if (currentEpisodePos + 1 < currentSeason.episodes.length) {
        this.closeVideoPlayer(false).then(videoInfo => this.playMediaService.play(this.data, currentSeason.episodes[currentEpisodePos + 1]));
      } else if (currentSeasonPos + 1 < this.data.seasons.length) {
        // Play Next season episode
        this.closeVideoPlayer(false).then(videoInfo => this.playMediaService.play(this.data, this.data.seasons[currentSeasonPos + 1].episodes[0]));
      } else {
        // No Next Episode
        this.closeVideoPlayer(true).then(videoInfo => { });
      }
    } else {
      this.closeVideoPlayer(true).then(videoInfo => { });
    }
  }

  /** Output listener which is listening player events  */
  playerEvents(event) {
    switch (event.type) {
      case "VideoEnd":
        this.onVideoEnd();
        break;
    }
  }

  /** Event triggered when user want to change media  */
  changeMedia(data) {
    this.data = data;
    this.vpcService.lock(this.data.video.vpcToken, this.data.video.interval);
    this.player.oldListeners = true;
    this.player.initShaka();
  }
}